import React, { act, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/payroll/employeeColumns";
import { getClientWiseEmployees } from "../../api/request/payroll/payroll";
import View from "../../assets/View";
import BackButton from "../../components/button/BackButton";
import GlobalTooltip from "../../components/common/GlobalTooltip";
import LoadableButton from "../../components/button/LoadableButton";
import moment from "moment";
import { ReactComponent as Email } from "../../assets/email.svg";
import { ReactComponent as User } from "../../assets/User.svg";

const ClientWiseEmployeeList = () => {
  const { id } = useParams(); // get client id from URL
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();


  const fetchEmployees = async () => {
    try {
      setIsLoading(true);
      const { data } = await getClientWiseEmployees({ client_id: id });

      setData(
        data?.data?.map((item) => ({
          ...item,
          address: (
            <div className="w-[100px] truncate" title={item?.address}>
              {item?.address}
            </div>
          ),
          dob: item?.dob ? moment(item.dob).format("MMM DD, YYYY") : "--",
          joining_date: item?.dob ? moment(item.joining_date).format("MMM DD, YYYY") : "--",
          created_at: moment(item?.created_at).format("lll"),
          exemption: (
            <p
              className={` ${item?.exemption === "yes"
                ? "text-green-500 font-bold capitalize"
                : item?.exemption === "no"
                  ? "text-red-600 font-bold capitalize"
                  : ""
                }`}
            >
              {item?.exemption ? item.exemption : "--"}
            </p>
          ),

          action: (
            <GlobalTooltip title="View Payroll History">
              <button onClick={() => navigate(`/payroll_history/${item?.id}`, {
                state: { employee: item },
              })} >
                <View />
              </button>
            </GlobalTooltip>
          ),
        })) || []
      );
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchEmployees();
    }
  }, [id]);
  const { name, email } = state?.client || {};


  return (
    <div className="border rounded-xl bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <div className="flex gap-3 items-center">
          <BackButton />
          <p className="title">Client’s Employees</p>
        </div>
        <div className="flex gap-3 justify-between items-center">
          {/* 
          <LoadableButton
            className="btn btn-primary !px-4"
            onClick={() => navigate(`/payroll/view_payroll/${id}`)}
          >
            View Payroll
          </LoadableButton> */}
          <div className="flex items-center space-x-3">
            <div className="mx-5 my-5">
              <p className="text-sm text-gray-600 flex items-center mb-1">
                <User className="mr-1 size-5" /> {name}
              </p>
              <p className="text-sm text-gray-600 flex items-center">
                <Email className="mr-1 size-5" /> {email}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <SkeletonTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          pagination={true}
        />
      </div>
    </div>
  );
};

export default ClientWiseEmployeeList;
